var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9982 5.85568C15.2086 5.71477 15.4833 5.71477 15.6937 5.85568L22.4137 10.3557C22.587 10.4717 22.691 10.6665 22.691 10.875C22.691 11.0835 22.587 11.2783 22.4137 11.3943L15.6937 15.8943C15.4833 16.0352 15.2086 16.0352 14.9982 15.8943L8.27822 11.3943C8.10496 11.2783 8.00098 11.0835 8.00098 10.875C8.00098 10.6665 8.10496 10.4717 8.27822 10.3557L14.9982 5.85568ZM9.74925 10.875L15.346 14.6228L20.9427 10.875L15.346 7.12719L9.74925 10.875Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3729 12.0095C11.5748 12.2894 11.5115 12.6801 11.2316 12.882L9.73024 13.9647L15.346 17.6288L20.9617 13.9647L19.4604 12.882C19.1804 12.6801 19.1171 12.2894 19.319 12.0095C19.5209 11.7295 19.9116 11.6662 20.1916 11.8681L22.4316 13.4835C22.5986 13.604 22.6956 13.7991 22.6908 14.005C22.686 14.211 22.58 14.4013 22.4075 14.5139L15.6875 18.8985C15.48 19.0339 15.212 19.0339 15.0044 18.8985L8.28445 14.5139C8.11193 14.4013 8.00595 14.211 8.00115 14.005C7.99634 13.7991 8.09332 13.604 8.2604 13.4835L10.5004 11.8681C10.7804 11.6662 11.171 11.7295 11.3729 12.0095Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78516 14C5.13033 14 5.41016 14.2798 5.41016 14.625V20.125C5.41016 20.4702 5.13033 20.75 4.78516 20.75C4.43998 20.75 4.16016 20.4702 4.16016 20.125V14.625C4.16016 14.2798 4.43998 14 4.78516 14Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19217 17.4241C2.44118 17.1851 2.83682 17.1932 3.07587 17.4422L4.785 19.2225L6.49413 17.4422C6.73318 17.1932 7.12883 17.1851 7.37783 17.4241C7.62684 17.6632 7.63491 18.0588 7.39587 18.3078L5.23587 20.5578C5.11801 20.6806 4.95518 20.75 4.785 20.75C4.61482 20.75 4.45199 20.6806 4.33413 20.5578L2.17413 18.3078C1.93509 18.0588 1.94316 17.6632 2.19217 17.4241Z",
    fill: "#1A181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78613 10.75C4.44095 10.75 4.16113 10.4702 4.16113 10.125L4.16113 4.625C4.16113 4.27982 4.44096 4 4.78613 4C5.13131 4 5.41113 4.27982 5.41113 4.625L5.41113 10.125C5.41113 10.4702 5.13131 10.75 4.78613 10.75Z",
    fill: "#1A181E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37912 7.32587C7.13011 7.56491 6.73447 7.55684 6.49542 7.30783L4.78629 5.52748L3.07715 7.30783C2.83811 7.55684 2.44246 7.56491 2.19345 7.32587C1.94445 7.08682 1.93637 6.69117 2.17542 6.44217L4.33542 4.19217C4.45328 4.0694 4.6161 4 4.78629 4C4.95647 4 5.1193 4.0694 5.23715 4.19217L7.39716 6.44217C7.6362 6.69117 7.62813 7.08682 7.37912 7.32587Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.89e9b434a227479bfec54bfe6c108dfd.svg";
export { ForwardRef as ReactComponent };